module.exports = "/images/logo-kemenkeu-cb777f2194f6501ea5c3ffe41ecc1435.png";